import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Layout from '../components/layout/Layout';
import ClientForm from '../components/clients/ClientForm';
import { clientApi } from '../services/api';

const EditClientPage = () => {
  const [client, setClient] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // Load client data when component mounts
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const loadedClient = await clientApi.getById(id);
        setClient(loadedClient);
      } catch (error) {
        toast.error('Client not found');
        console.error('Error loading client:', error);
        navigate('/');
      }
    };
    
    fetchClient();
  }, [id, navigate]);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    
    try {
      // Format dates properly
      const formattedValues = {
        ...values,
        lastContact: values.lastContact ? new Date(values.lastContact).toISOString() : '',
        nextFollowUp: values.nextFollowUp ? new Date(values.nextFollowUp).toISOString() : '',
      };
      
      // Update client via API
      await clientApi.update(id, formattedValues);
      
      toast.success('Client updated successfully!');
      navigate('/');
    } catch (error) {
      toast.error('Failed to update client. Please try again.');
      console.error('Error updating client:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!client) {
    return (
      <Layout>
        <div className="text-center py-5">
          <p>Loading client data...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="mb-4">
        <h2>Edit Client</h2>
        <p className="text-muted">Update client information below</p>
      </div>
      <ClientForm 
        client={client} 
        onSubmit={handleSubmit} 
        isLoading={isLoading} 
      />
    </Layout>
  );
};

export default EditClientPage;
